// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-c889b41a]{font-family:Open Sans,sans-serif;font-size:.8rem;letter-spacing:-.02rem}[dir] div[data-v-c889b41a]{padding:4px 8px;border-radius:.5rem}.toFill[data-v-c889b41a]{color:#2444ec}[dir] .toFill[data-v-c889b41a]{background-color:#ecedf6}.fixed[data-v-c889b41a]{color:#f14a3f}[dir] .fixed[data-v-c889b41a]{background-color:#fde9e8}.formula[data-v-c889b41a]{color:#10da61}[dir] .formula[data-v-c889b41a]{background-color:#e9fdf1}", ""]);
// Exports
module.exports = exports;
